export default __webpack_public_path__ + "static/media/laser.373d639d.mp3";